import { render, staticRenderFns } from "./AddUpdateCat.vue?vue&type=template&id=6d031afa&"
import script from "./AddUpdateCat.vue?vue&type=script&lang=ts&"
export * from "./AddUpdateCat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports